import {
  CommandeEntity,
  GetLastEleveCommandeQuery
} from '../../../graphql/generated/graphql';
import { ToRequiredType } from '../../../types/typeDef';
import { getCommandeLinePanierFromQuery } from '../commandLines';
import {
  CommandeDef,
  CommandeDefWithEleve
} from '../../../types/commande/commande.def';
import { orderNeedToBeReminded } from '../../commande/orderNeedToBeReminded';

export const getCommandeDefFromQuery = (
  commande: Partial<CommandeEntity>
): CommandeDef => ({
  ...(commande.attributes as ToRequiredType<typeof commande.attributes>),
  client: {
    id: commande?.attributes?.client?.data?.id,
    ...(commande?.attributes?.client?.data?.attributes as ToRequiredType<
      typeof commande.attributes.client.data.attributes
    >)
  },
  id: commande?.id,
  commandelines: commande?.attributes?.commandelines?.data?.map(cl =>
    getCommandeLinePanierFromQuery(cl)
  ),
  payment: commande?.attributes?.payment,
  numerocommande: commande?.attributes?.numerocommande,
  methodepaiement: commande?.attributes?.methodepaiement,
  createdAt: commande?.attributes?.createdAt,
  totalttc: commande?.attributes?.totalttc,
  prixTotal: commande?.attributes.prixTotal,
  controlled: commande?.attributes?.controlled,
  livraison: commande?.attributes?.livraison,
  customerContributedToTheOng: commande?.attributes.customerContributedToTheOng,
  orderNeedToBeReminded: orderNeedToBeReminded(
    commande?.attributes?.methodepaiement,
    commande.attributes.status,
    commande.attributes.paymentreminder,
    commande.attributes.createdAt
  )
});

export const getCommandeDefWithEleveFromQuery = (
  commande: GetLastEleveCommandeQuery['usersPermissionsUser']['data']['attributes']['commandes']['data'][0]
): CommandeDefWithEleve => ({
  ...getCommandeDefFromQuery(commande),
  user: {
    firstname: commande.attributes.user.data.attributes.firstname,
    lastname: commande.attributes.user.data.attributes.lastname,
    email: commande.attributes.user.data.attributes.email
  }
});
